import { Config, fetchJSON } from '@ratehub/base-ui';


async function fetchQualifyingRate() {
    return fetchJSON({
        url: `${Config.MORTGAGE_RATES_API_URL}/qualifying-rate`,
        arrayFormat: 'bracket',
    }, 'fetchQualifyingRate');
}


export default fetchQualifyingRate;
